/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderImgVo } from './OrderImgVo';
import {
    OrderImgVoFromJSON,
    OrderImgVoFromJSONTyped,
    OrderImgVoToJSON,
    OrderImgVoToJSONTyped,
} from './OrderImgVo';
import type { InboundPictureOrderGoodsInfoVo } from './InboundPictureOrderGoodsInfoVo';
import {
    InboundPictureOrderGoodsInfoVoFromJSON,
    InboundPictureOrderGoodsInfoVoFromJSONTyped,
    InboundPictureOrderGoodsInfoVoToJSON,
    InboundPictureOrderGoodsInfoVoToJSONTyped,
} from './InboundPictureOrderGoodsInfoVo';
import type { InboundPictureOrderInfoVo } from './InboundPictureOrderInfoVo';
import {
    InboundPictureOrderInfoVoFromJSON,
    InboundPictureOrderInfoVoFromJSONTyped,
    InboundPictureOrderInfoVoToJSON,
    InboundPictureOrderInfoVoToJSONTyped,
} from './InboundPictureOrderInfoVo';

/**
 * 
 * @export
 * @interface OrderInfoForInboundPictureOrderVo
 */
export interface OrderInfoForInboundPictureOrderVo {
    /**
     * 订单id
     * @type {number}
     * @memberof OrderInfoForInboundPictureOrderVo
     */
    orderId?: number;
    /**
     * 订单信息列表
     * @type {Array<InboundPictureOrderInfoVo>}
     * @memberof OrderInfoForInboundPictureOrderVo
     */
    orderInfoList?: Array<InboundPictureOrderInfoVo>;
    /**
     * 商品信息列表
     * @type {Array<InboundPictureOrderGoodsInfoVo>}
     * @memberof OrderInfoForInboundPictureOrderVo
     */
    goodsInfoList?: Array<InboundPictureOrderGoodsInfoVo>;
    /**
     * 订单图片列表
     * @type {Array<OrderImgVo>}
     * @memberof OrderInfoForInboundPictureOrderVo
     */
    orderImgList?: Array<OrderImgVo>;
}

/**
 * Check if a given object implements the OrderInfoForInboundPictureOrderVo interface.
 */
export function instanceOfOrderInfoForInboundPictureOrderVo(value: object): value is OrderInfoForInboundPictureOrderVo {
    return true;
}

export function OrderInfoForInboundPictureOrderVoFromJSON(json: any): OrderInfoForInboundPictureOrderVo {
    return OrderInfoForInboundPictureOrderVoFromJSONTyped(json, false);
}

export function OrderInfoForInboundPictureOrderVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForInboundPictureOrderVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderInfoList': json['orderInfoList'] == null ? undefined : ((json['orderInfoList'] as Array<any>).map(InboundPictureOrderInfoVoFromJSON)),
        'goodsInfoList': json['goodsInfoList'] == null ? undefined : ((json['goodsInfoList'] as Array<any>).map(InboundPictureOrderGoodsInfoVoFromJSON)),
        'orderImgList': json['orderImgList'] == null ? undefined : ((json['orderImgList'] as Array<any>).map(OrderImgVoFromJSON)),
    };
}

export function OrderInfoForInboundPictureOrderVoToJSON(json: any): OrderInfoForInboundPictureOrderVo {
    return OrderInfoForInboundPictureOrderVoToJSONTyped(json, false);
}

export function OrderInfoForInboundPictureOrderVoToJSONTyped(value?: OrderInfoForInboundPictureOrderVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderInfoList': value['orderInfoList'] == null ? undefined : ((value['orderInfoList'] as Array<any>).map(InboundPictureOrderInfoVoToJSON)),
        'goodsInfoList': value['goodsInfoList'] == null ? undefined : ((value['goodsInfoList'] as Array<any>).map(InboundPictureOrderGoodsInfoVoToJSON)),
        'orderImgList': value['orderImgList'] == null ? undefined : ((value['orderImgList'] as Array<any>).map(OrderImgVoToJSON)),
    };
}

